<template>
  <transition name="fade-slide">
    <div v-if="isVisible" class="fixed bottom-0 left-0 right-0 z-50 p-0 sm:p-4 sm:pb-4 pointer-events-none">
      <!--
        Pasa por tokens en vez de la escala gray-800/gray-300: este banner
        aparece sobre la landing (clara) y sobre el panel (claro u oscuro
        según el usuario), así que no puede asumir un fondo.
      -->
      <div class="max-w-4xl mx-auto bg-surface backdrop-blur-md shadow-elev-lg sm:rounded-2xl rounded-t-2xl p-4 ring-1 ring-inset ring-border pointer-events-auto flex flex-col sm:flex-row items-center gap-3 sm:gap-4">

        <div class="flex-1 text-xs sm:text-sm text-text-secondary w-full mb-1 sm:mb-0">
          <h3 class="font-bold text-text mb-0.5">Privacidad y Cookies</h3>
          <p class="leading-snug">
            Usamos cookies para mejorar nuestros servicios y analizar tus hábitos de navegación.
            <a href="/politicas-de-privacidad" class="text-primary hover:underline font-medium">Leer más</a>.
          </p>
        </div>

        <div class="flex flex-row sm:flex-row gap-2 w-full sm:w-auto mt-2 sm:mt-0">
          <button
            @click="rejectCookies"
            class="flex-1 sm:flex-none px-3 py-1.5 border border-border hover:border-border-strong rounded-lg text-xs font-medium text-text-secondary hover:bg-hover-overlay hover:text-text transition-colors"
          >
            Rechazar
          </button>

          <button
            @click="acceptCookies"
            class="flex-1 sm:flex-none px-3 py-1.5 bg-primary rounded-lg text-xs font-medium text-on-primary hover:bg-primary-hover transition-colors shadow-sm"
          >
            Aceptar todas
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const isVisible = ref(false)

const CONSENT_KEY = 'olitom_cookie_consent'

onMounted(() => {
  // Comprobar si el usuario ya tomó una decisión previamente
  const consent = localStorage.getItem(CONSENT_KEY)
  
  if (!consent) {
    // Si no hay decisión, mostrar banner
    isVisible.value = true
  } else if (consent === 'accepted') {
    // Si aceptó antes, disparar confirmación al Consent Mode
    initAnalytics()
  } else if (consent === 'rejected') {
    // Si rechazó antes, asegurar que el estado se mantenga en denied
    updateConsent('denied')
  }
})

const acceptCookies = () => {
  localStorage.setItem(CONSENT_KEY, 'accepted')
  isVisible.value = false
  initAnalytics()
}

const rejectCookies = () => {
  localStorage.setItem(CONSENT_KEY, 'rejected')
  isVisible.value = false
  updateConsent('denied')
}

const initAnalytics = () => {
  // Actualizar el estado de Google Consent Mode a Granted
  updateConsent('granted')
}

// Función auxiliar para integrar con Google gtag
const updateConsent = (status) => {
  window.dataLayer = window.dataLayer || []
  function gtag(){ window.dataLayer.push(arguments) }
  
  gtag('consent', 'update', {
    'ad_storage': status,
    'ad_user_data': status,
    'ad_personalization': status,
    'analytics_storage': status
  })
}
</script>

<style scoped>
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.5s ease;
}
.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(100%);
}
</style>
